export enum NotificationMessageType {
    SUCCESS = 'success',
    ERROR = 'error',
    SAVE = 'save',
    SYNC = 'sync'
}
